import Image from "components/Elements/Image/Image.tsx";
import React, { useState, useEffect } from "react";
import {
  languageShortList,
  languageShortListFullName,
  languageListObjects,
} from "utils/jumbomailSettings.js";

const FormLanguage = ({
  formLanguage,
  setFormLanguage,
  settitleDropDown,
  setDropDownLanguage,
  setUpdateBeforeSave,
  setDirectionForm,
}) => {

  const [activeIndex, setActiveIndex] = useState(
    languageShortListFullName.indexOf(formLanguage)
  );

  useEffect(() => {
    if (formLanguage !== languageShortListFullName[activeIndex]) {
      settitleDropDown(languageListObjects[activeIndex]);
      setDropDownLanguage(languageShortList[activeIndex]);
      setFormLanguage(languageShortListFullName[activeIndex]);
      setUpdateBeforeSave({ mode: true, action: "language" });
      setDirectionForm(
        languageShortListFullName[activeIndex] === "he-IL" ||
          languageShortListFullName[activeIndex] === "ar-SA"
          ? "rtl"
          : "ltr"
      );
    }
  }, [activeIndex]);

  return (
    <div className="form-languages">
      <ul>
        {languageListObjects.map((item, index) => (
          <li
            onClick={() => setActiveIndex(index)}
            key={index}
            className="language"
          >
            <span className="text">{item.title}</span>
            {index === activeIndex ? (
              <span className="active-icon">
                <Image name="create-form/v-icon" ext="svg" alt="" title="" />
              </span>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FormLanguage;
